import React from 'react'
import CarModalInput from '../inputs/CarModalInput'
import GenderInput from '../inputs/GenderInput'
import CarModalSelect from '../inputs/CarModalSelect'
import { input_class, label_class } from '../../functions/stateList'
import DatePicker from 'react-multi-date-picker'
import persian from 'react-date-object/calendars/persian'
import persian_fa from 'react-date-object/locales/persian_fa'
import moment from 'moment-jalaali'

function UserModalBody({ isSubmit, inputs, inputHandler, error, customer_types, setInputs }) {
  const date = new Date()
  let day = date.getDate()
  let month = date.getMonth() + 1
  let year = date.getFullYear()

  let currentDate = moment(`${year}/${month}/${day}`, 'YYYY/MM/DD').format('jYYYY/jMM/jDD')

  return (
    <div className="relative p-6 flex flex-col">
      <CarModalInput
        title={'نام و نام خانوادگی'}
        type={'text'}
        isSubmit={isSubmit}
        name={'full_name'}
        value={inputs?.full_name}
        inputHandler={inputHandler}
        error={error}
      />
      <GenderInput
        isSubmit={isSubmit}
        name={'gender'}
        value={inputs?.gender}
        inputHandler={inputHandler}
        error={error}
      />

      <CarModalInput
        maxLength={11}
        title={'تلفن همراه'}
        type={'number'}
        isSubmit={isSubmit}
        name={'mobile'}
        value={inputs?.mobile}
        inputHandler={inputHandler}
        error={error}
      />

      <CarModalSelect
        title={'دسته بندی کاربر'}
        isSubmit={isSubmit}
        name={'customer_type'}
        value={inputs?.customer_type}
        inputHandler={inputHandler}
        error={error}
        list={customer_types}
        text_key={'value'}
      />

      <label htmlFor="birth_date" className={label_class}>
        تاریخ تولد
        <div className={input_class} style={{ direction: 'rtl' }}>
          <DatePicker
            maxDate={currentDate}
            mapDays={({ date }) => {
              let props = {}
              let isWeekend = date.weekDay.index === 6

              if (isWeekend) props.className = 'highlight highlight-red'

              return props
            }}
            className={'dark:border-slate-600 dark:bg-slate-800 dark:text-amber-100'}
            calendar={persian}
            locale={persian_fa}
            calendarPosition="top-right"
            format={'YYYY/MM/DD'}
            value={inputs?.birth_date}
            onChange={(e) => setInputs({ ...inputs, birth_date: e })}
          />
        </div>
      </label>
    </div>
  )
}

export default React.memo(UserModalBody)
